import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  ApplicationState,
  getPasswordRecoveryState,
} from '../../../store/reducers';
import * as RecoveryMethodsActions from '../../store/actions/password-recovery-management.actions';
import { Store } from '@ngrx/store';
import { PasswordRecoveryManagementState } from '../../store/reducers/password-recovery-management.reducer';
import { getRecoveryMethodError } from '../../../store/reducers/index';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mprd-mobile-pending-container',
  templateUrl: 'mobile-pending-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobilePendingContainerComponent implements OnInit, OnDestroy {
  activatePendingSmsRecoveryMethodForm: UntypedFormGroup;
  mobileNumber: string;
  showChangeNumber = false;
  showLoadingSpinner: boolean;
  $getRecoveryMethodError: Subscription;

  constructor(
    private builder: UntypedFormBuilder,
    private store: Store<ApplicationState>,
    private changeDetector: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.store
      .select(getPasswordRecoveryState)
      .subscribe(
        (passwordRecoveryManagementState: PasswordRecoveryManagementState) => {
          if (
            passwordRecoveryManagementState.passwordRecoveryManagement &&
            passwordRecoveryManagementState.passwordRecoveryManagement.sms
          ) {
            this.mobileNumber =
              passwordRecoveryManagementState.passwordRecoveryManagement.sms.mobile;
          }
        },
      );
    this.activatePendingSmsRecoveryMethodForm = this.builder.group({
      token: ['', [Validators.required]],
    });
    this.$getRecoveryMethodError = this.store
      .select(getRecoveryMethodError)
      .subscribe(() => {
        this.showLoadingSpinner = false;
        this.changeDetector.markForCheck();
      });
  }

  ngOnDestroy() {
    this.$getRecoveryMethodError.unsubscribe();
  }

  onMobileNumberSubmitFormStatusAndValue(mobileNumberSubmitFormStatusAndValue: {
    mobileNumberSubmitFormStatus: string;
    mobileNumber: string;
    errors: any;
  }) {
    if (mobileNumberSubmitFormStatusAndValue.mobileNumberSubmitFormStatus) {
      this.showChangeNumber = false;
      this.setSmsRecovery(mobileNumberSubmitFormStatusAndValue.mobileNumber);
    }
  }

  onMobileNumberSubmitCancel() {
    this.showChangeNumber = !this.showChangeNumber;
  }

  setSmsRecovery(mobileNumber = this.mobileNumber) {
    this.store.dispatch(
      new RecoveryMethodsActions.SetSmsRecoveryMethodAction(mobileNumber),
    );
  }

  activateSmsRecoveryMethod() {
    if (this.activatePendingSmsRecoveryMethodForm.value.token) {
      this.showLoadingSpinner = true;
      this.store.dispatch(
        new RecoveryMethodsActions.ActivateSmsRecoveryMethodAction(
          this.activatePendingSmsRecoveryMethodForm.value.token,
        ),
      );
    }
  }

  isTokenEmpty() {
    return this.activatePendingSmsRecoveryMethodForm.value.token?.length === 0;
  }
}
